import React from "react";

interface TextfieldProps {
  label: string;
  placeholder: string;
  id: string;
  name: string;
  autocomplete?: string;
  textarea?: boolean;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error?: string;
}

const Textfield: React.FC<TextfieldProps> = ({
  label,
  placeholder,
  id,
  name,
  autocomplete,
  textarea = false,
  value,
  onChange,
  error,
}) => {
  return (
    <div>
      {label && (
        <label htmlFor={id} className="tracking-wide text-white">
          {label}
        </label>
      )}
      {!textarea ? (
        <input
          type="text"
          name={name}
          id={id}
          autoComplete={autocomplete}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="mt-3 w-full border border-white/20 bg-transparent px-4 py-3 text-white outline-none focus:ring-1 focus:ring-indigo-500"
        />
      ) : (
        <textarea
          name="message"
          id={id}
          cols={30}
          rows={6}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="mt-3 w-full border border-white/20 bg-transparent px-4 py-3 text-white outline-none focus:ring-1 focus:ring-indigo-500"
        />
      )}
      <div className="text-red-500 text-sm">{error}</div>
    </div>
  );
};

export default Textfield;
